import React from 'react'

function Page404() {
  return (
    <div className='main-container not-found text-center mt-auto' >
        <h1><b>404</b></h1>
        <h2><b>Opps! page not found</b></h2>
        <h5>Sorry, the page you're loking for dosen't exist</h5>
    </div>
  )
}

export default Page404
